<template>
  <v-app class="container">
    <v-content>
      <barra />
      <v-card>
        <v-card-title v-if="!gindicadores" class="grey lighten-4 change-font" primary-title>
          <div class="spinner-grow"></div>Cargando indicadores &#8230;
        </v-card-title>
        <v-card-title v-else class="grey lighten-4 change-font" primary-title>Detalle por indicador</v-card-title>
        <v-card-text>
          <v-container v-if="punto">
            <v-layout wrap>
              <v-flex md2 class="d-none d-md-block">
                <img
                  width="120px"
                  class="mx-auto d-block gray"
                  v-bind:src="'data:image/jpeg;base64,' + punto.icono"
                />
              </v-flex>
              <v-flex md10>
                <v-layout>
                  <v-menu
                    :open-on-hover="false"
                    :close-on-content-click="true"
                    :offset-x="false"
                    :offset-y="false"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="content-title" :style="{ color: punto.color }">
                        {{ punto.nombre }}
                        <v-btn text icon v-on="on">
                          <v-icon>icon-list</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in gpuntos"
                        :key="index"
                        @click="seleccionarpunto(item)"
                      >
                        <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-layout>
                <v-layout justify-center class="d-none d-md-block">{{ punto.descripcion }}</v-layout>
              </v-flex>
            </v-layout>
            <v-select
              :clearable="false"
              :searchable="false"
              :filterable="false"
              label="Sector:"
              item-text="nombre"
              :readonly="sectorbloqueado"
              :items="sectores"
              v-model="sector"
              return-object
              style="min-width:400px"
            ></v-select>
            <v-select
              :clearable="false"
              :searchable="false"
              :filterable="false"
              label="Entidad:"
              item-text="nombre"
              :readonly="entidadbloqueada"
              :items="entidades"
              return-object
              v-model="entidad"
              style="min-width:400px"
            ></v-select>
            <div v-if="gindicadores">
              <v-data-table
                :no-data-text="gnodata"
                :headers="headers"
                :items="indicadores"                              
                class="elevation-2"
                hide-default
                :items-per-page="10" 
              >
                <template v-slot:item.avancemostrar="{ item }">
                  <v-chip v-if="(item.avancemostrar!=='-' && item.avancemostrar!=='' )" :color="semaforo(item.avancemostrar)" dark>{{ item.avancemostrar }}</v-chip>
                  <div v-if="item.avancemostrar === ''">
                    <span                      
                      small
                      class="mr-2"                      
                    >{{item.avancemostrar}}</span>
                    </div>
                    <div v-if="item.avancemostrar === '-'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span                                       
                       v-on="on"
                      class="mr-2"                      
                    >{{item.avancemostrar}}</span>                         
                        </template>
                        <span>Entidad no registró avance</span>
                      </v-tooltip>
                    </div>     

                </template>
                <template v-slot:item.avancegestionmostrar="{ item }">
                  <p v-if="(item.avancegestionmostrar!=='*' &&  item.avancegestionmostrar!=='-' &&  item.avancegestionmostrar!=='' )" dark>{{ item.avancegestionmostrar }}</p>
                  <div v-if="item.avancegestionmostrar === ''">
                    <span                      
                      small
                      class="mr-2"                      
                    >{{item.avancegestionmostrar}}</span>
                    </div>
                    <div v-if="item.avancegestionmostrar === '*'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span                                       
                            v-on="on"
                            class="mr-2"                      
                          >No Aplica</span>                         
                        </template>
                        <span>La entidad no relacionó Hitos</span>
                      </v-tooltip>
                    </div>
                    <div v-if="item.avancegestionmostrar === '-'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span                                       
                            v-on="on"
                            class="mr-2"                      
                          >{{item.avancegestionmostrar}}</span>                         
                        </template>
                        <span>La entidad no ha reportado avances</span>
                      </v-tooltip>
                    </div>   

                </template>
                <template v-slot:item.action="{ item }">
                  <div v-if="item.finalizado === true">
                     <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                         <v-icon small class="mr-2" v-on="on" @click="verdetalle(item)">remove_red_eye</v-icon>
                      </template>
                      <span>Ver</span>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small color="red" class="mr-2" v-on="on">mdi-eye</v-icon>
                      </template>
                      <span>Sin ficha técnica</span>
                    </v-tooltip>
                  </div>
                </template>
                 <template v-slot:footer>
                  <div id="div1" style="width:100%;align:right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width:100%;text-align: right;"
                          v-show="indicadores.length>0"
                          class="btn btn-default"
                          :data="indicadores"
                          :exportFields="exportable"
                          name="indicadores.xls"
                          type="xls"
                          worksheet="Información"
                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                          >mdi-file-download-outline</v-icon>
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>

            </div>
          </v-container>
        </v-card-text>
      </v-card>
       <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>
    </v-content>
  </v-app>
</template>



<script>
import { mapActions, mapGetters } from "vuex";
import barra from "@/components/content/barra-nav.vue";
import store from "../../stores/index.js";
export default {
  name: "detalleentidad",
  components: {
    barra
  },
  data: function() {
    return {
       exportable: {
        Código: "codigo",
        Nombre: "nombre",
        "Descripción" : "descripcion",
        "Meta" : "metaperiodo", 
        "Unidad" : "idunidadNavigation.nombre",
        "Avance físico (%)": "avancemostrar",
        "Avance gestión (%)": "avancegestionmostrar",
        Entidad: "entidades.nombre",
        "Ficha técnica": {
        field: "finalizado",
          callback: value => {
          if (value) return "Sí";
            else return "No";
          }
        },
        Inicio: "inicio",
        Fin: "fin"
      },
      periodoId: 0,
      sector: null,
      entidad: null,
      punto: null,
      estrategia: null,
      sectorbloqueado: false,
      entidadbloqueada: false,
      color: "",
      sectores: [],
      puntos: [],
      indicadores: [],
      headers: [
        { text: "Código", value: "codigo", fixed: true, width: "100px" },
        { value: "nombre", text: "Nombre", width:"35%" },
        { value: "metaperiodo", text: "Meta", width: "50px", sortable: false },
        { value: "idunidadNavigation.nombre", text: "Unidad", width: "100px" },
        {
          value: "avancemostrar",
          align: "center",
          text: "Avance físico (%)",
          width: "180px"
        },
        {
          value: "avancegestionmostrar",
          align: "center",
          text: "Avance gestión (%)",
          width: "180px", sortable:false
        },
        { text: "Detalle", value: "action", sortable: false, align: "center" }
      ],
      
      //Mensajes informativos
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      snack: false,
      snackColor: "",
      snackText: "",
    };
  },
  beforeUpdate() {},
  updated() {},
  created() {
    this.get_semaforos();
    this.sectores = this.gsectores;
    this.entidades = this.gentidades;
    this.puntos = this.gpuntos;
    if (this.puntos === null) {
      this.cargarpuntos();
    } else {
      this.punto = this.puntos[0];
    }
    if (this.sectores.length === 0) {
      this.cargarsectores();
    } else {
      this.definirsector();
    }
    if (this.entidades.length === 0) {
      this.cargarentidades();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "gentidades",
      "gpuntos",
      "gsectores",
      "gopciones",
      "gindicadores",
      "gsemaforos"
    ]),
    ...mapGetters("barra", ["gperiodo"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),    
    itemsporpagina() {      
      if ( !isNaN( this.itemsPerPageSopCuan )) return this.itemsPerPageSopCuan;
      else return 1;
    }
  },
  methods: {
    ...mapActions([
      "Getentidad",
      "get_sectores",
      "get_puntos",
      "get_indicadoresentidad",
      "get_semaforos"
    ]),
    semaforo(valor) {
      if (valor !== '-')
      {
      let progreso = parseFloat(valor.replace("%", "").replace(",", "."));
      if (progreso>100)
      {
        progreso = 100;
      }

      if (this.gsemaforos.length === 0) {
        store.watch(
          () => store.getters["gsemaforos"],
          () => {
            return this.gsemaforos.filter(
              p => p.valorinicio <= progreso && p.valorfinal > progreso
            )[0].color;
          }
        );
      } else {
        return this.semaforo1(progreso);
      }
      }
      else
      {
        return 'white';
      }
    },
    semaforo1(item) {
      let color = '';
      let valor = 0;
      if(typeof parseInt(item) == 'number')
        valor = parseInt(item);
  
      if (valor <= 25)
        color = '#FF0000'

      if (valor > 25 && valor <= 50)
        color = '#FF6300'
      
      if (valor > 50 && valor <= 75)
        color = '#FFFF00'

      if (valor > 75 && valor <= 99)
        color = '#0AC22D'

      if (valor == 100 )
        color = '#008000'        

      return color;
    },
    usuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    definirentidad() {
      let opcionentidad = this.gopciones.filter(
        p => p.codigo === "O006-2" || p.codigo === "O006-1"
      )[0];
      let usuario = this.usuario();      
      this.entidades = this.gentidades.filter(
        p => p.idsector === this.sector.idsector
      );
      if (opcionentidad === undefined) {
        this.entidadbloqueada = true;
      }
      if (this.sector.idsector === usuario.idsector) {
        this.entidad = this.entidades.filter(
          p => p.identidad === usuario.identidad
        )[0];
      } else {
        this.entidad = this.entidades[0];
      }
    },
    definirsector() {
      let opcionsector = this.gopciones.filter(p => p.codigo === "O006-1")[0];
      if (opcionsector === undefined) {
        this.sectorbloqueado = true;
      }
      this.sector = this.sectores.filter(
        p => p.idsector === this.usuario().idsector
      )[0];
    },
    cargarpuntos() {
      this.get_puntos();
    },
    cargarsectores() {
      this.get_sectores();
    },
    cargarentidades() {
      this.Getentidad();
    },
    verdetalle(item) {
       let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
      let env = global[global.env];
      this.$aes.setKey(env.path.secret);
       let cifra = this.$aes.encrypt(item.idindicador.toString());
      let temporal =   Math.random().toString(36).substring(2, 6) + cifra  +  Math.random().toString(36).substring(2, 6);
      console.log(temporal);
      let encrypted = this.$aes.encrypt(temporal);
      encrypted = encrypted.replace(/\//g, "AbcYq");
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      this.$router.push("/detalleentidadindicador/" + encrypted);      
    },
    cargarindicadores() {
      if (this.entidad !== null && this.gperiodo != null) {
        this.get_indicadoresentidad({
          params: {
            identidad: this.entidad.identidad,
            idperiodo: this.gperiodo
          },
          data: {}
        });
      }
    },
    seleccionarpunto(b) {
      this.punto = b;
    },
    definirindicadores() {
      if (this.punto !== null && this.gindicadores !== null) {
        this.indicadores = this.gindicadores.filter(
          p => p.idpunto === this.punto.idpunto
        );
      }
    }
  },
  watch: {
    pilar: function() {},
    punto: function() {
      this.definirindicadores();
    },
    entidad: function() {
      this.cargarindicadores();
    },
    sector: function() {
      if (this.gentidades.length > 0) {
        this.definirentidad();
      } else {
        store.watch(
          () => store.getters["gentidades"],
          () => {
            this.definirentidad();
          }
        );
      }
    },
    gpuntos: function() {
      this.puntos = this.gpuntos;
      this.punto = this.puntos[0];
    },
    gsectores: function() {
      this.sectores = this.gsectores;
      this.definirsector();
    },
    gperiodo: function() {
      this.cargarindicadores();
    },
    gindicadores: function() {
      this.definirindicadores();
    },
    ginformation() {
      this.MesaggeInfo = this.ginformation;
      console.log(this.MesaggeInfo.mensajeRespuesta);
      this.snack = true;
    }
  }
};
</script>
